<template>
  <v-card class="px-6 pt-2 pb-3 main-bonus-template" v-if="Object.keys(bonusTemplate).length > 1">
    <v-form v-model="valid">
      <select-project
        v-model="bonusTemplate.entity_id"
        :rules="[v => !!v || 'Project is required']"
        required
        class="mb-4"
        :default-value="false"
      >
      </select-project>

      <v-row class="mx-0">

        <v-text-field
          v-model="bonusTemplate.name"
          label="Name"
          :rules="[v => !!v || 'Name is required']"
          required
          :suffix="bonusTemplate.bonus_template_id ? '#' + bonusTemplate.bonus_template_id : ''"
        />
        <v-btn
          v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
          class="mt-4 ml-4"
          color="info"
          small
          @click="openNewBonus()"
        >
          Add bonus
        </v-btn>
      </v-row>

      <v-container v-if="newBonus">
        <v-card>

          <v-tabs
            v-model="bonusTypeModel"
            centered
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="bonus" href="#bt-bonus">Bonus</v-tab>
            <v-tab key="overdraft" href="#bt-overdraft">Overdraft</v-tab>
            <v-tab key="sport_bonus" href="#bt-sport_bonus">Sport Bonus</v-tab>
            <v-tab key="freespins" href="#bt-freespins">Freespins</v-tab>

          </v-tabs>
          <v-card-text>

            <v-tabs-items
              v-model="bonusTypeModel"
              class="bonus_template-tab pt-2"
              touchless
            >
              <v-tab-item
                id="bt-bonus"
              >
                <bonus-form
                  ref="bt-formtab-bonus"
                  :bonus.sync="bonus.form"
                  :providerSystemsAliases.sync="providerSystemsAliases"
                  :providerBrandsAliases.sync="providerBrandsAliases"
                  :loadingGames="loadingGames"
                  :games="bonus.games"
                  :brands.sync="bonus.brands"
                />
              </v-tab-item>
              <v-tab-item
                id="bt-overdraft"
              >
                <overdraft-form
                  ref="bt-formtab-overdraft"
                  :bonus.sync="overdraft.form"
                  :providerSystemsAliases.sync="providerSystemsAliases"
                  :providerBrandsAliases.sync="providerBrandsAliases"
                  :loadingGames="loadingGames"
                  :games="bonus.games"
                  :brands.sync="bonus.brands"
                />
              </v-tab-item>
              <v-tab-item
                id="bt-sport_bonus"
              >
                <sport_bonus-form
                  ref="bt-formtab-sport_bonus"
                  :bonus.sync="sport_bonus.form"
                  :sport_templates="sport_bonus.templates"
                  :valid.sync="sport_bonus.valid"
                />
              </v-tab-item>
              <v-tab-item
                id="bt-freespins"
              >
                <freespins-form
                  ref="bt-formtab-freespins"
                  :bonus.sync="freespins.form"
                  :providerSystemsAliases.sync="providerSystemsAliases"
                  :providerBrandsAliases.sync="providerBrandsAliases"
                  :loadingGames="loadingGames"
                  :games.sync="freespins.games"
                  :brands.sync="freespins.brands"
                />
              </v-tab-item>
            </v-tabs-items>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="success"
              small
              @click="addBonus()"
            >
              Ok
            </v-btn>
            <v-spacer />
            <v-btn
              color="warning"
              small
              @click="newBonus = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-divider class="mt-5" />
      </v-container>

      <v-container>
        <template v-for="(item, k) of bonusTemplate.data">
          <v-card v-if="item && item.type" class="mb-5">
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'bonus_template_update', value: true})"
              color="green darken-2"
              small
              icon
              style="position: absolute; right: 0; top: 0"
              @click="removeBonus(k)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-card-text>
              <component
                class="bonus_template-tab"
                :is="(item.type + '-form')"
                :bonus.sync="item"
                :providerSystemsAliases.sync="providerSystemsAliases"
                :providerBrandsAliases.sync="providerBrandsAliases"
                :sport_templates="sport_bonus.templates"
                :loadingGames="loadingGames"
                :games.sync="item.type !== 'freespins' ? bonus.games : freespins.games"
                :brands.sync="item.type !== 'freespins' ? bonus.brands : freespins.brands"
              />
            </v-card-text>
          </v-card>
        </template>
      </v-container>

    </v-form>
  </v-card>

</template>

<style scoped>
  .main-bonus-template.v-card {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .bonus_template-tab >>> .bonus-template_lh-28 input {
    line-height: 28px !important;
  }
</style>

<script>
  import { includes, uniq, isNaN, toNumber, isEmpty, isArray, map, get, filter, concat, cloneDeep, debounce } from 'lodash'
  import { API } from '@/utils/api'
  import Overdraft from '@/components/bonus-template/form/Overdraft'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    props: [ 'bonusTemplate', 'loading' ],

    components: {
      SelectProject,
      Overdraft,
      BonusForm: () => import('@/components/bonus-template/form/Bonus'),
      OverdraftForm: () => import('@/components/bonus-template/form/Overdraft'),
      FreespinsForm: () => import('@/components/bonus-template/form/Freespins'),
      Sport_bonusForm: () => import('@/components/bonus-template/form/SportBonus'),
    },

    data: () => ({
      valid: false,
      config: {},
      newBonus: false,
      bonusTypeModel: '',

      bonus: {
        initForm: {
          valid: null,
          name: '',
          expire_days: 10,
          rollover_type: 'bonus',
          status: 'new',
          wager: 30,
          deposit_amount_percent: 0,
          deposit_amount: 0,
          additional_rules: [],
        },
        form: {},
        brands: [],
        brandsFilter: [],
        games: [],
      },

      overdraft: {
        initForm: {
          valid: null,
          name: '',
          status: 'new',
          expire_days: 10,
          additional_rules: [],
        },
        form: {},
        brands: [],
        brandsFilter: [],
        games: [],
        name: {}
      },

      sport_bonus: {
        initForm: {
          internal: true,
          valid: null,
          name: '',
          rollover_type: 'bonus',
          release_type: 'bonus',
          bonus_type: 'STD',
          status: 'new',
          wager: 35,
          deposit_amount_percent: 0,
          deposit_amount: 0,
          expire_days: 10,
          additional_rules: [],
        },
        templates: [],
        form: {},
      },

      freespins: {
        initForm: {
          valid: null,
          rollover_type: 'bonus',
          status: 'new',
          wager: 50,
          expire_days: 10,
          additional_rules: [],
          amount_by_day: [],
        },
        form: {},
        brands: [],
        brandsFilter: [],
        games: [],
      },

      loadingGames: false,
    }),

    watch: {
      valid (v) {
        this.$emit('update-validation', v)
      },

      'bonusTemplate.data': {
        handler: function (v) {
          if (!v) return
          let valid = true
          for (let item of v) {
            valid = (item.hasOwnProperty('valid') ? item.valid : true) && valid
          }
          this.$emit('update-validation', this.valid && valid)
        },
        deep: true,
      },

      'bonusTemplate.entity_id': {
        handler: debounce(function () {
          this.loadGames()
          this.loadSportBonusTemplates()
        }, 800),
        deep: true,
      }
    },

    methods: {
      isNumber: (v) => !isNaN(toNumber(v)) || isEmpty(v),

      async addBonus () {

        let action = this.bonusTypeModel.replace('bt-', '')

        this.$refs['bt-formtab-' + action].$refs['bt-form-' + action].validate()

        if (this[action].form.valid && await this.$root.$confirm('Confirm', 'Add bonus in template', { width: 470 })) {
          if (!this.bonusTemplate.data) this.bonusTemplate.data = []

          if (this[action]) {
            if (!this.bonusTemplate.data || !isArray(this.bonusTemplate.data)) {
              this.bonusTemplate.data = []
            }

            this[action].form.type = action
            this.bonusTemplate.data.push(cloneDeep(this[action].form))
            this.newBonus = false
            this.reset()
          }
        }
      },

      removeBonus (k) {
        if (this.bonusTemplate.bonus_template_id) {
          const bonusesLeft = this.bonusTemplate.data.filter(bonus => !!bonus).length
          if (bonusesLeft === 1) {
            return this.$showError('Template must have at least one associated bonus')
          }
        }

        this.$root.$confirm('Confirm', 'Remove bonus from template', { width: 470 })
          .then(yes => {
            if (yes) {
              this.$set(this.bonusTemplate.data, k, null)
            }
          })
      },

      openNewBonus: function () {
        if (!this.newBonus) {
          this.reset()
        }
        this.newBonus = this.newBonus || { data: [] }
      },

      reset: function () {
        this.bonusTypeModel = 'bonus'

        this.bonus.form = cloneDeep(this.bonus.initForm)
        this.overdraft.form = cloneDeep(this.overdraft.initForm)
        this.sport_bonus.form = cloneDeep(this.sport_bonus.initForm)
        this.freespins.form = cloneDeep(this.freespins.initForm)
      },

      loadSportBonusTemplates () {
        if (!this.bonusTemplate) return

        return API.call('/$v/bonus_template/sport_bonus_list.json', { deleted: [ 0 ] }, null, this.bonusTemplate.entity_id).then(resp => {
          this.sport_bonus.templates = map(resp.data, o => ({ text: o.name, value: o.sport_bonus_id }))
        }).catch(() => {
        })
      },

      loadGames: function () {
        this.loadingGames = true
        return API.call('/$v/game/list.json', {}, null, this.bonusTemplate.entity_id).then(resp => {
          this.bonus.games = resp.data
          this.bonus.brands = uniq(map(resp.data, 'brand.alias'))
          this.freespins.games = filter(resp.data, (g) => g.allow_freespins > 0)
          this.freespins.brands = uniq(map(this.freespins.games, 'brand.alias'))
        }).catch(e => {
        }).finally(r => {
          this.loadingGames = false
        })
      }

    },

    computed: {
      providerBrandsAliases: function () {
        return map(this.bonus.games, (i) => [ get(i, 'system_alias'), get(i, 'brand_alias') ].join('.'))
      },
      providerSystemsAliases: function () {
        return map(this.bonus.games, 'system_alias')
      }
    },
  }
</script>
